import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getAdminToken = () => {
  return localStorage.getItem('adminToken');
};

export const getAdminUsername = () => {
  return localStorage.getItem('adminUsername');
};

export const isAdminAuthenticated = () => {
  return !!getAdminToken();
};

export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUsername');
};

export const verifyAdminToken = async () => {
  try {
    const token = getAdminToken();
    if (!token) return false;

    const response = await axios.get(`${API}/admin/verify`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data.valid;
  } catch (error) {
    console.error('Token verification failed:', error);
    logoutAdmin();
    return false;
  }
};

export const getAuthHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
